import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "currentColor" }));
export default SvgDot;
